export default __webpack_public_path__ + "static/media/Gallery3.4603963e.webp";